module.exports = __webpack_public_path__ + "static/img/vip_privilege11.de56a0c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/vip/vip_privilege11.png
// module id = L8a+
// module chunks = 0